import { Component, Input } from '@angular/core';
import { TeamSeason } from '../model/team-season';

@Component({
  selector: 'navigation',
  templateUrl: 'navigation.html',
  styleUrls: ["navigation.css"]
})

export class NavigationComponent {
  @Input() teamSeasons: Map<String, TeamSeason> = new Map<String, TeamSeason>();

  constructor() { }
}
